import { render, staticRenderFns } from "./CheckRoundedIcon.vue?vue&type=template&id=169c2c5b&"
import script from "./CheckRoundedIcon.vue?vue&type=script&lang=ts&"
export * from "./CheckRoundedIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports